class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.parentLink = this.summary.querySelector('.mega-menu__parent-link');
    this.supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));

    if (this.parentLink) {
      this.parentLink.addEventListener('click', this.onParentLinkClick.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onMouseEnter() {
    if (!this.supportsHover.matches) return;

    clearTimeout(this.closeTimeout);
    this.open();
  }

  onMouseLeave() {
    if (!this.supportsHover.matches) return;

    this.closeTimeout = setTimeout(() => this.close(), 150);
  }

  onFocusIn() {
    clearTimeout(this.closeTimeout);
    this.open();
  }

  onParentLinkClick(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    window.location.assign(this.parentLink.href);
  }

  onSummaryClick(event) {
    if (event.target.closest('a')) return;

    event.preventDefault();
    this.parentLink.click();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
